import { z } from "zod";
import {
  TopolBlockCssClassSchema,
  TopolBlockSchema,
  TopolColorSchema,
  TopolColorBearingSchema,
} from "../commonSchema";

const TopolSpacerBlockStyleAttributesSchema = z.object({
  height: z.string().or(z.number()).catch("50px"),
  "container-background-color": TopolColorSchema.optional().catch(undefined),
  "container-gradient": TopolColorBearingSchema.optional().catch(undefined),
});

export const TopolSpacerBlockSchema = TopolBlockSchema.extend({
  tagName: z.literal("mj-spacer"),
  attributes: z
    .object({
      ...TopolSpacerBlockStyleAttributesSchema.shape,
      containerWidth: z.number().catch(600),
      "css-class": TopolBlockCssClassSchema.optional().catch(undefined),
    })
    .default({
      height: "50px",
      containerWidth: 600,
    }),
});

export type TopolSpacerBlock = z.infer<typeof TopolSpacerBlockSchema>;
